/**
 * @file Homepage.js
 * @module src/js/pages/Homepage
 * @description
 * **Page component for the homepage of the EDALab website.**
 * - Renders key sections including news, advisor information, current research topics, and contact details.
 *
 * @version
 * <p>
 *  2025-11-29: First version with documentation. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 * </p>
 */
import News from '../components/News';
import Advisor from '../components/Advisor';
import CurrentResearchTopics from '../components/CurrentResearchTopics';
import ContactUs from '../components/ContactUs';

export default function Homepage() {
    return (
        <>
            <News />
            <Advisor typeList={[0]} />
            <CurrentResearchTopics />
            <ContactUs />
        </>
    );
}
